export var ReactNativeToWebEvent;
(function (ReactNativeToWebEvent) {
    ReactNativeToWebEvent["EnteringBackground"] = "EnteringBackground";
    ReactNativeToWebEvent["ResumingFromBackground"] = "ResumingFromBackground";
    ReactNativeToWebEvent["GainingFocus"] = "GainingFocus";
    ReactNativeToWebEvent["LosingFocus"] = "LosingFocus";
    ReactNativeToWebEvent["AndroidBackButtonPressed"] = "AndroidBackButtonPressed";
    ReactNativeToWebEvent["ColorSchemeChanged"] = "ColorSchemeChanged";
    ReactNativeToWebEvent["KeyboardSizeChanged"] = "KeyboardSizeChanged";
    ReactNativeToWebEvent["KeyboardWillShow"] = "KeyboardWillShow";
    ReactNativeToWebEvent["KeyboardWillHide"] = "KeyboardWillHide";
    ReactNativeToWebEvent["KeyboardDidShow"] = "KeyboardDidShow";
    ReactNativeToWebEvent["KeyboardDidHide"] = "KeyboardDidHide";
    ReactNativeToWebEvent["ReceivedFile"] = "ReceivedFile";
    ReactNativeToWebEvent["ReceivedLink"] = "ReceivedLink";
    ReactNativeToWebEvent["ReceivedText"] = "ReceivedText";
    ReactNativeToWebEvent["OpenFilePreview"] = "OpenFilePreview";
})(ReactNativeToWebEvent || (ReactNativeToWebEvent = {}));
